export default {
  addRouters: (state: any) => state.addRouters,
  isAddRouters: (state: any) => state.isAddRouters,
  sidebar: (state: any) => state.app.sidebar,
};
